<template>
  <div v-if="activePage" class="flex space-x-4 flex-1">
    <div class="flex flex-col space-y-3 flex-1 max-w-100">
      <uiSwitch
        :value="activePage.isMainPage"
        label="Основная страница"
        @input="changeMainPage(activePage, $event)"
      />

      <uiTextarea v-model="activePage.title" label="Заголовок страницы" />

      <div class="pb-4">
        <p class="m-0 text-sm mb-1 opacity-50">Блоки</p>

        <p
          v-if="!pageBlocks.length"
          class="m-0 text-sm text-center text-gray-400"
        >
          Нет блоков 🗿
        </p>

        <draggable :list="activePage.blocks" class="space-y-3" handle=".handle">
          <div
            v-for="(block, i) in pageBlocks"
            :key="i"
            class="flex space-x-2 bg-gray-100 rounded-2xl text-black py-3 px-4 block-item item group items-center"
          >
            <div
              class="cursor-pointer opacity-0 transition-opacity text-gray-500 handle inline-flex group-hover:opacity-100"
            >
              <Icon icon="ph:dots-six-vertical-bold" height="16" />
            </div>

            <div class="flex-1">
              <p
                class="font-medium m-0 text-base"
                :class="{ 'opacity-30': !block.title }"
              >
                {{
                  block.title ||
                  (block.items[0]?.title
                    ? `[${block.items[0].title}]`
                    : 'Без названия')
                }}
              </p>
              <p class="font-medium m-0 text-sm opacity-30">
                {{ block.kindLabel }}
              </p>
            </div>

            <div
              class="cursor-pointer opacity-0 transition-opacity text-red-500 inline-flex group-hover:opacity-100"
              @click="deletePageBlock(i)"
            >
              <Icon icon="ph:trash" height="16" />
            </div>
          </div>
        </draggable>
      </div>

      <uiButton
        v-if="activePage?.id.startsWith('new_')"
        class="ml-auto px-4"
        @click="createPage(activePage)"
      >
        Создать
      </uiButton>

      <div v-else class="flex">
        <uiButton class="px-4" color="red" @click="deletePage(activePage)">
          Удалить страницу
        </uiButton>

        <uiButton class="ml-auto px-4" @click="updatePage(activePage)">
          Сохранить
        </uiButton>
      </div>
    </div>

    <div class="flex flex-col space-y-3 flex-1 max-w-100 pt-12.5">
      <div class="flex space-x-3 items-end">
        <uiDropdown
          label="Добавить блок"
          :clearSearchOnSelect="true"
          :options="blocksOptions"
          :value="blocksOptions.find(a => a.value === newBlockId)"
          @input="newBlockId = $event.value"
          class="flex-1"
        />

        <uiButton class="px-2" @click="addPageBlock">
          <Icon icon="ph:plus-bold" width="24" />
        </uiButton>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import Draggable from 'vuedraggable'
import List from '../components/List.vue'
import { usePages } from '../composables/pages'
import { useBlocks } from '../composables/blocks'

export default {
  components: {
    Draggable,
    List
  },
  setup () {
    const router = useRouter()
    const route = useRoute()

    const activePage = ref()
    const { blocks, blockKindMap, getBlockById } = useBlocks({
      router,
      route
    })
    const { pages, createPage, updatePage, deletePage, changeMainPage } =
      usePages({
        router,
        route
      })
    onMounted(() => {
      activePage.value = pages.value.find(page => page.id === route.params.id)
    })

    const pageBlocks = computed(() => {
      if (!activePage.value) return []

      return activePage.value.blocks
        .map(id => {
          const block = getBlockById(id)
          if (block == null) return null

          return {
            ...block,
            kindLabel: blockKindMap[block.kind] ?? block.kind
          }
        })
        .filter(Boolean)
    })

    const newBlockId = ref('')
    const blocksOptions = computed(() =>
      blocks.value.map(block => ({
        value: block.id,
        label: `${
          block.title ||
          (block.items[0]?.title ? `[${block.items[0].title}]` : 'Без названия')
        } (${blockKindMap[block.kind] ?? block.kind})`
      }))
    )

    function addPageBlock () {
      if (!newBlockId.value) return

      activePage.value.blocks.push(newBlockId.value)
      newBlockId.value = ''
    }

    function deletePageBlock (index) {
      activePage.value.blocks.splice(index, 1)
    }

    return {
      activePage,
      pages,
      createPage,
      updatePage,
      deletePage,
      changeMainPage,
      pageBlocks,

      newBlockId,
      blocksOptions,

      addPageBlock,
      deletePageBlock
    }
  }
}
</script>
